module.exports = __webpack_public_path__ + "img/quick-burrito-lunch.1945043c.jpg";